import * as PG from './pages';

export const ROUTE_URLS = {
  HOME: '/',
  USERS: '/users',
  EDIT_USER: '/users/:id/edit',
  CREATE_USER: '/users/create',
  BRANCHES: '/branches',
  CREATE_BRANCH: '/branches/create',
  EDIT_BRANCH: '/branches/:id/edit',
  BRANCH_PRICES: '/branches/:id/prices',
  EDIT_BRANCH_PRICES: '/branches/:id/prices/edit',
  PRODUCTS: '/products',
  ADD_PRODUCT: '/products/add',
  CREATE_PRODUCT: '/products/create',
  EDIT_PRODUCT: '/products/:id/edit',
  REPORTS: '/reports',
  CHECKOUT: '/checkout',
  CREATE_REPORT: '/reports/create',
  BRANCH_REPORTS: '/reports/:id',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',};

const crumb = (key, to) => ({ key, to });

// Restricted routes are only accessible to admins.
// `page` routes are only accessible to employees who were granted that page.

const routes = [
  {
    path: ROUTE_URLS.USERS,
    exact: true,
    name: 'Users',
    component: PG.Users,
    restricted: true,
    crumbs: [crumb('nav.users')],
  },
  {
    path: ROUTE_URLS.CREATE_USER,
    exact: true,
    name: 'Create user',
    component: PG.CreateUser,
    restricted: true,
    crumbs: [crumb('nav.users', ROUTE_URLS.USERS), crumb('users.createTitle')],
  },
  {
    path: ROUTE_URLS.EDIT_USER,
    exact: true,
    name: 'Edit user',
    component: PG.User,
    crumbs: [crumb('header.profile')],
  },
  {
    path: ROUTE_URLS.PRODUCTS,
    exact: true,
    name: 'Products',
    component: PG.Products,
    restricted: true,
    crumbs: [crumb('nav.products')],
  },
  {
    path: ROUTE_URLS.ADD_PRODUCT,
    exact: true,
    name: 'Add product',
    component: PG.AddProduct,
    restricted: true,
    crumbs: [crumb('nav.products', ROUTE_URLS.PRODUCTS), crumb('products.addStockTitle')],
  },
  {
    path: ROUTE_URLS.CREATE_PRODUCT,
    exact: true,
    name: 'Create product',
    component: PG.CreateProduct,
    restricted: true,
    crumbs: [crumb('nav.products', ROUTE_URLS.PRODUCTS), crumb('products.createTitle')],
  },
  {
    path: ROUTE_URLS.EDIT_PRODUCT,
    exact: true,
    name: 'Edit product',
    component: PG.EditProduct,
    restricted: true,
    crumbs: [crumb('nav.products', ROUTE_URLS.PRODUCTS), crumb('products.editTitle')],
  },
  {
    path: ROUTE_URLS.BRANCHES,
    exact: true,
    name: 'Branches',
    component: PG.Branches,
    page: 'branches',
    crumbs: [crumb('nav.branches')],
  },
  {
    path: ROUTE_URLS.CREATE_BRANCH,
    exact: true,
    name: 'Create branch',
    component: PG.CreateBranch,
    restricted: true,
    crumbs: [crumb('nav.branches', ROUTE_URLS.BRANCHES), crumb('branches.createTitle')],
  },
  {
    path: ROUTE_URLS.EDIT_BRANCH,
    exact: true,
    name: 'Edit branch',
    component: PG.EditBranch,
    restricted: true,
    crumbs: [crumb('nav.branches', ROUTE_URLS.BRANCHES), crumb('branches.editTitle')],
  },
  {
    path: ROUTE_URLS.BRANCH_PRICES,
    exact: true,
    name: 'Branch prices',
    component: PG.BranchPrices,
    page: 'branches',
    crumbs: [crumb('nav.branches', ROUTE_URLS.BRANCHES), crumb('branches.prices')],
  },
  {
    path: ROUTE_URLS.EDIT_BRANCH_PRICES,
    exact: true,
    name: 'Edit branch prices',
    component: PG.EditBranchPrices,
    page: 'branches',
    crumbs: [crumb('nav.branches', ROUTE_URLS.BRANCHES), crumb('branches.editPrices')],
  },
  {
    path: ROUTE_URLS.REPORTS,
    exact: true,
    name: 'Reports',
    component: PG.Reports,
    page: 'reports',
    crumbs: [crumb('nav.reports')],
  },
  {
    path: ROUTE_URLS.CHECKOUT,
    exact: true,
    name: 'Reports',
    component: PG.Checkout,
    page: 'checkout',
    crumbs: [crumb('nav.checkout')],
  },
  {
    path: ROUTE_URLS.BRANCH_REPORTS,
    exact: true,
    name: 'Branch reports',
    component: PG.Reports,
    page: 'reports',
    crumbs: [crumb('nav.reports', ROUTE_URLS.REPORTS), crumb('nav.branches')],
  },
  {
    path: ROUTE_URLS.CREATE_REPORT,
    exact: true,
    name: 'Create report',
    component: PG.CreateReport,
    page: 'createReport',
    crumbs: [crumb('nav.reports', ROUTE_URLS.REPORTS), crumb('nav.createReport')],
  },
  {
    path: ROUTE_URLS.HOME,
    exact: true,
    name: 'Home',
    component: PG.Home,
    page: 'dashboard',
    crumbs: [crumb('nav.dashboard')],
  },
  {
    path: '*',
    exact: false,
    name: 'Not Found',
    component: PG.NotFound,
    crumbs: [crumb('notFound.title')],
  },
];

export default routes;
